import { useParams, Link, Navigate } from 'react-router'
import ArrowBack from '@mui/icons-material/ArrowBack'
import { Alert, Button, CircularProgress, Stack } from '@mui/material'
import useIsInCurrentAccount from '@/hooks/useIsInCurrentAccount'
import { useGetAuthUser } from '@/service-library/hooks/auth-user'
import Breadcrumb from '@/components/breadcrumbs/Breadcrumb'
import UserDetails from './UserDetails'

export default function UserPage() {
  const { id } = useParams()
  const isInSameAccount = useIsInCurrentAccount()

  const { user, isPending, isError, queryKey } = useGetAuthUser({
    id: id ?? '',
    enabled: isInSameAccount,
  })

  if (!isInSameAccount) return <Navigate to="/settings/users" replace />

  return (
    <>
      {user && <Breadcrumb label={user.name} url={`/settings/users/${id}`} />}

      {!isPending && !user && (
        <Alert severity="error">
          Unable to load this user.{' '}
          {isError
            ? 'Please try again later.'
            : 'You may not have access or this user does not exist.'}
        </Alert>
      )}

      {isPending ? (
        <Stack alignItems="center" sx={{ p: 4 }}>
          <CircularProgress />
        </Stack>
      ) : (
        <>
          <Button
            sx={{ ml: '-4px', my: 2 }}
            startIcon={<ArrowBack />}
            component={Link}
            to="../"
            variant="text"
          >
            Back to Users
          </Button>
          {user && <UserDetails user={user} queryKey={queryKey} />}
        </>
      )}
    </>
  )
}
